import { pageConstants } from '../constants';
import { pageService } from '../../services';

export const pageActions = {
  getPage,
  updatePage
}

/*
ACTION: Get Page By ID
*/
function getPage(addToast, pageID) {
  return dispatch => {
    dispatch(request());
    return pageService.getPage(pageID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if (typeof error === 'object' && addToast) {
            Object.keys(error).map((key) => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: pageConstants.GET_REQUEST } }
  function success(item) { return { type: pageConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: pageConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Page
*/
function updatePage(addToast, formData) {
  return dispatch => {
    dispatch(request());
    console.log(formData);
    return pageService.updatePage(formData)
      .then(
        response => {
          if (addToast) {
            addToast('بروزرسانی برگه با موفقیت انجام شد', { appearance: 'success', autoDismiss: true });
          }
          dispatch(success(response.status));
        },
        error => {
          if (typeof error === 'object' && addToast) {
            Object.keys(error).map((key) => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: pageConstants.UPDATE_REQUEST } }
  function success(status) { return { type: pageConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: pageConstants.UPDATE_FAILURE, error } }
}